import type { Client } from '../api/types';
import { eL } from '../utils/format';
import { verHistorial } from '../store/actions/visit.actions';

export function ClientsTable({ list }: { list: Client[] }) {
  return (
    <table class="desktop-table">
      <thead>
        <tr>
          <th>Cliente</th>
          <th>Dirección</th>
          <th>Zona</th>
          <th>Visitas/mes</th>
          <th>Estado</th>
          <th>Días</th>
        </tr>
      </thead>
      <tbody>
        {list.map((c) => (
          <tr key={c.id} onClick={() => verHistorial(c.id)}>
            <td>
              <strong>{c.nombre}</strong>
            </td>
            <td>{c.direccion || '-'}</td>
            <td>{c.zona || '-'}</td>
            <td>{c.visitasMensuales}</td>
            <td>
              <span class={'badge ' + c.estado}>{eL(c.estado)}</span>
            </td>
            <td>
              {c.diasRestantes !== null && c.diasRestantes >= 0
                ? c.diasRestantes + 'd'
                : Math.abs(c.diasRestantes ?? 0) + 'd atraso'}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
